// components/ui/loading/skeletons/GhostBar.js
const GhostBar = ({
  width,
  height = "14px",
  circle = false,
  className = "",
  style = {},
}) => (
  <div
    className={`skeleton-v2-pulse ${className}`}
    style={{
      width,
      height,
      borderRadius: circle ? "50%" : "4px",
      ...style,
    }}
  />
);

export default GhostBar;
